<h1 mat-dialog-title>Muestras</h1>
<div class="table-scroll">
  <mat-spinner *ngIf="loading"></mat-spinner>
  <table *ngIf="!loading" class="table-content">
    <tr>
      <th>Nombre</th>
      <th class="cell-date">Trajo</th>
    </tr>

    <tr *ngFor="let item of items">
      <td>{{item.ProcedureName}}</td>
      <td class="cell-date">
        <mat-checkbox [(ngModel)]="item.Received"></mat-checkbox>
      </td>
    </tr>
  </table>
</div>
<div class="clearfix">
  <div class="pull-right">
    <button *ngIf="!data.isAdmission" [disabled]="loading" mat-button type="button" (click)="update()">Aceptar</button>
    <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
  </div>
</div>
